export default "__VITE_ASSET__b2c7b8d5__"